import { render, staticRenderFns } from "./NotiFicationSet.vue?vue&type=template&id=19bd8ff5&"
import script from "./NotiFicationSet.vue?vue&type=script&lang=js&"
export * from "./NotiFicationSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports